
import { definitionsFromContext } from "stimulus/webpack-helpers";
import application from "stimulus_application";
import "./similar_unit_types_slider.css";

const context = require.context("./", true, /_controller\.js$/);
application.load(definitionsFromContext(context));
